import isEmpty from 'lodash/isEmpty'

const initialState = {
  isAuthenticated: false,
  user: {},
  menu:[],
  sets:[],
  comprights:[],
  rights:{}
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'SET_CURRENT_USER':
      return {
        ...state,
        isAuthenticated: !isEmpty(action.user),
        user: action.user
      };
    case 'EDIT_CURRENT_USER':
      return {
        ...state,
        user: action.user
      }
    case 'FETCH_SETS':
      return {
        ...state,
        sets: action.sets
      }
    case 'FETCH_MENU':
      return {
        ...state,
        menu: action.menu
      }
    case 'FETCH_COMPRIGHTS':
      return {
        ...state,
        comprights: action.comprights
      }
    case 'FETCH_USER_RIGHTS':
      return {
        ...state,
        rights: action.rights
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js